
const testimonialData = JSON.parse(document.getElementById('upcart-testimonial-json').textContent)

function createCartTestimonial () {
  const testimonial = document.createElement('div');
  testimonial.style.fontSize = '14px';
  testimonial.style.fontFamily = 'inherit';
  testimonial.style.marginTop = '10px';
  testimonial.style.display = 'flex';
  testimonial.style.flexDirection = 'column';
  testimonial.style.justifyContent = 'space-between';

  // --- First Row (2 columns) ---
  const firstRow = document.createElement('div');
  firstRow.style.display = 'flex';
  firstRow.style.flexDirection = 'row';
  firstRow.style.gap = '12px';
  firstRow.style.justifyContent = 'space-between';
  firstRow.style.alignItems = 'center';

  // -- First Col (2 rows) --
  const firstCol = document.createElement('div');
  firstCol.style.display = 'flex';
  firstCol.style.flexDirection = 'column';

  // --- First row: "customer status"
  const verified = document.createElement('div');
  verified.textContent = testimonialData.customer_status;
  verified.style.fontWeight = 'bold';
  verified.style.color = '#EA6039';

  // --- Second row: 2 columns
  const secondRow = document.createElement('div');
  secondRow.style.display = 'flex';
  secondRow.style.flexDirection = 'row';
  secondRow.style.gap = '8px';
  secondRow.style.alignItems = 'center';

  // ---- First col: Daniella image
  const daniellaImg = document.createElement('img');
  daniellaImg.src = testimonialData.customer_testimonial_image;
  daniellaImg.alt = testimonialData.customer_name;
  daniellaImg.style.width = '40px';
  daniellaImg.style.height = '40px';
  daniellaImg.style.borderRadius = '50%';
  daniellaImg.style.objectFit = 'cover';

  // ---- Second col: 2 rows
  const nameAndStars = document.createElement('div');
  nameAndStars.style.display = 'flex';
  nameAndStars.style.flexDirection = 'column';
  nameAndStars.style.gap = '2px';

  // ----- First row: "Daniella & Tank"
  const name = document.createElement('div');
  name.textContent = testimonialData.customer_name;
  name.style.fontWeight = 'bold';
  name.style.color = '#5b3e0f';

  // ----- Second row: 5 stars
  const stars = document.createElement('div');
  for (let i = 0; i < 5; i++) {
    const star = document.createElement('span');
    star.innerHTML = '&#9733;'; // Unicode star
    star.style.color = '#EA6039';
    star.style.fontSize = '16px';
    star.style.marginRight = '1px';
    stars.appendChild(star);
  }

  nameAndStars.appendChild(name);
  nameAndStars.appendChild(stars);

  secondRow.appendChild(daniellaImg);
  secondRow.appendChild(nameAndStars);

  firstCol.appendChild(verified);
  firstCol.appendChild(secondRow);

  // -- Second Col: Tank before/after image
  const tankImg = document.createElement('img');
  tankImg.src = testimonialData.extra_testimonial_image;
  tankImg.alt = 'Tank Before and After';
  tankImg.style.maxHeight = '60px';
  tankImg.style.objectFit = 'cover';
  tankImg.style.borderRadius = '6px';

  firstRow.appendChild(firstCol);
  firstRow.appendChild(tankImg);

  // --- Second Row: Testimonial text
  const testimonialText = document.createElement('div');
  testimonialText.textContent = testimonialData.customer_testimonial;
  testimonialText.style.color = '#637381';

  // Assemble everything
  testimonial.appendChild(firstRow);
  testimonial.appendChild(testimonialText);
  return testimonial
}

const t33_updateCart = function() {

  const upcartDomEl = document.querySelector('#upCart');
  const shadowRoot = upcartDomEl.shadowRoot;
  const oldStack = shadowRoot.querySelector('.upcart-footer');

  // avoid anoying refresh
  if (oldStack.classList.contains('t33-modification')) {
    return;
  }
  oldStack.classList.add('t33-modification');
  // end avoid anoying refresh

  oldStack.style.marginLeft = '0'
  // create testimonial elemnent and append it
  const testimonial = createCartTestimonial()
  oldStack.prepend(testimonial);
}


const observeUpCartShadow = () => {
  const upCart = document.querySelector('#upCart');
  if (!upCart) return;

  const checkShadow = () => {
    const shadow = upCart.shadowRoot;
    if (shadow) {

      // Now observe changes inside the shadow
      const innerObserver = new MutationObserver(() => {

        innerObserver.disconnect();

        try {
          t33_updateCart()
        }  catch(e) {}

        // 🔁 Reconnect observer after a short delay
        setTimeout(() => {
          innerObserver.observe(shadow, { childList: true, subtree: true });
        }, 200); // tweak delay as needed
      });

      innerObserver.observe(shadow, { childList: true, subtree: true });
    }
  };
  // Run once now
  checkShadow();
  // Watch if Shadow DOM gets re-attached later
  const rootObserver = new MutationObserver(checkShadow);
  rootObserver.observe(upCart, { childList: true, subtree: true });
};

// Delay startup slightly to ensure UpCart is in the DOM
setTimeout(observeUpCartShadow, 500);